

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('squid/index');

require('components/xo-beaver/dist/logger');

require('components/xo-return-to-merchant/dist/util');

require('components/xo-models/src/checkout/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function ($q, $config, $meta, $timeout, $window, $logger, $log, $feature, $ReturnToMerchant, $locale, $util, $FallbackError, $state, $rootScope, $populate, $CheckoutCartModel, $CheckoutAppDataModel, $pxp) {
    return function (err) {
        var reason = err.reason;
        var product = err.product;
        var entry_point = err.entryPoint;
        var params = err.params;
        var model = {};

        function getFallbackUrl(urlParams) {
            if ($rootScope.wps) {
                return $populate(model, {
                    checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
                }).then(function () {
                    // defaulting for now to ensure backward compatibility
                    var base = $config.urls.fallbackUrl['buyNow'];
                    if (model.checkoutAppData.flags.is_cart_upload_flow) {
                        base = $config.urls.fallbackUrl['cartUpload'];
                    }
                    return $util.paypalURL(base, urlParams);
                });
            } else {
                return $q.when().then(function () {
                    var base = $config.urls.fallbackUrl[product];
                    return $util.paypalURL(base, urlParams);
                });
            }
        }

        function showGenericErrorPage(errorReason) {
            if ($rootScope.partnerIntegration) {
                $logger.info('partner_integration_fallback_to_genericErrorPage');
            }

            var code = errorReason || reason;
            code = code ? window.btoa(code) : code;

            $state.go('checkout.genericError', {
                code: code
            });
        }

        function doFallback() {
            $util.assert(reason, 'expected fallback reason');

            product = product || 'ux';

            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                token: $meta.token,
                fallback: 1,
                landing: entry_point,
                useraction: $util.param('useraction')
            });

            if ($rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if ($rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var wpsParams = void 0;
            if ($rootScope.wps) {
                wpsParams = $util.decodeAndParse($meta.xclickParams);
                $logger.info('wps_fallback', {
                    token: $meta.token,
                    reason: reason
                });
                $logger.info('wps_fallback_reason_' + reason, {
                    reason: reason
                });
            }

            return getFallbackUrl(urlParams).then(function (url) {
                if (!$config.fallbackEnabled && !entry_point) {
                    return $log.warn('Fallback inhibited by config', url);
                }

                if ($config.deploy.isLocal() && !entry_point) {
                    return $log.warn('Fallback inhibited in local mode.', url);
                }

                $logger.log(product ? 'info' : 'error', 'fallback', {
                    reason: reason,
                    product: product,
                    entry_point: entry_point,
                    error_desc: reason,
                    from: $rootScope.currentState || 'fallback',
                    to: product ? 'process_fallback_' + product : 'process_fallback'
                });

                $logger.info('fallback_reason_' + reason, {
                    reason: reason
                });

                $rootScope.$emit('loading');

                if (window.paypalCheckout) {
                    if (window.paypalCheckout.props.fallback) {
                        return window.paypalCheckout.props.fallback(url);
                    }
                    return $util.redirect(url);
                }

                if (product === 'ux') {
                    // Otherwise we can make a decision based on whether we're in the minibrowser or not
                    return $rootScope.wps ? $ReturnToMerchant.postTo(url, wpsParams) : $ReturnToMerchant.goTo(url);
                }

                // Safe to always return to Aries
                return $util.redirect(url);
            });
        }

        if ($rootScope.wps && $rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            $logger.info('wps_error_after_payment', {
                reason: reason
            });

            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
        }

        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        var isBeamIntegration = $meta.baToken && beamPattern.test($meta.baToken);
        var cartExchangeFailed = isBeamIntegration && beamPattern.test($meta.token);
        if (cartExchangeFailed) {
            product = 'ux';
        }

        if (product === 'ux') {

            // For Beam Integration - always show generic Error when cart exchange fails.
            // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
            if (isBeamIntegration && cartExchangeFailed) {
                return showGenericErrorPage();
            }

            // Throttle fallback for V0
            if ($rootScope.partnerIntegration) {

                $logger.info('partner_integration_fallback_enter');

                return $populate(model, {
                    checkoutCart: $CheckoutCartModel.instance($meta.token),
                    checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
                }).then(function () {
                    var pxpConfig = $config.ulMeta;

                    return $pxp(pxpConfig.hermesnodePxpConfig, {
                        'ctx.COUNTRY': model.checkoutAppData.merchant.merchant_country
                    }, 'xo_hermesnode_vzero_fallback_treatment').then(function (result) {
                        if (result) {
                            $logger.info('partner_integration_fallback_to_UX');
                            $window.resizeTo(screen.availWidth, screen.availHeight);
                            return doFallback();
                        }
                        return showGenericErrorPage();
                    });
                });
            }
        }

        return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
            if (appData.flags.disable_legacy_fallback) {
                $logger.error('fallback_inhibited_for_xo_order_tokens');
                return showGenericErrorPage();
            } else {
                return doFallback();
            }
        });
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./js/lib/fallback.js
 ** module id = 149
 ** module chunks = 1
 **/